/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PriceType = "AUTOMATED_OFFER" | "NET" | "RETAIL" | "WEEKLY_SALE" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type ItemPrice_item$ref = any;
export type ItemPrice_item = {
    readonly canMultipleQuantityBePurchased: boolean | null;
    readonly vertical: VerticalType | null;
    readonly pdpDisplayInfo?: {
        readonly pricing: {
            readonly showRetail: boolean | null;
            readonly showNet: boolean | null;
            readonly showSale: boolean | null;
            readonly showPUR: boolean | null;
            readonly showSold: boolean | null;
            readonly showOnHold: boolean | null;
        } | null;
    } | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly currency: Currency | null;
        } | null;
        readonly prices: ReadonlyArray<{
            readonly amount: {
                readonly amount: number | null;
                readonly convertedAmountList: ReadonlyArray<{
                    readonly amount: number | null;
                    readonly currency: Currency | null;
                } | null> | null;
            } | null;
            readonly pricePerPiece: unknown | null;
            readonly hidePrice: unknown | null;
            readonly negotiable: unknown | null;
            readonly type: PriceType | null;
            readonly status: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": ItemPrice_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "ItemPrice_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "canMultipleQuantityBePurchased",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vertical",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/)
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "prices",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Price",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "amount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": [
                                    (v1 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "convertedAmountList",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ConvertedAmountList",
                                        "plural": true,
                                        "selections": [
                                            (v1 /*: any*/),
                                            (v0 /*: any*/)
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "pricePerPiece",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hidePrice",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "negotiable",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "status",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "pdpDisplayInfo",
                        "name": "displayInfo",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "buyerId",
                                "variableName": "userId"
                            },
                            {
                                "kind": "Literal",
                                "name": "page",
                                "value": "pdp"
                            }
                        ],
                        "concreteType": "ItemDisplayInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "pricing",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PriceInfoDisplay",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showRetail",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showNet",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSale",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showPUR",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showSold",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "showOnHold",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'cf5255db4b48ddf80019212dc4fd0950';
export default node;
